import type { SectionHeadingProps } from './types';

import React from 'react';

import { Stack, Text } from '@/components';

const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  ...restProps
}) => {
  return (
    <Stack gap={30} textAlign={{ base: 'center', md: 'start' }} {...restProps}>
      <Text fontSize="3xl" fontWeight={800} lineHeight={4}>
        {title}
      </Text>
      <Text fontSize="2xl" fontWeight={700} lineHeight={4}>
        {subtitle}
      </Text>
    </Stack>
  );
};

export default SectionHeading;
